import { PathTypeAccountInfo } from 'models/commonModel';
import AgentMember from 'pages/account/account-option/AgentMember';
import AgentRegister from 'pages/account/account-option/AgentRegister';
import AgentSign from 'pages/account/account-option/AgentSign';
import BankAccount from 'pages/account/account-option/BankAccount';
import FundAccountTransfer from 'pages/account/account-option/FundAccountTransfer';
import FundBet from 'pages/account/account-option/FundBet';
import GiftCodeAccount from 'pages/account/account-option/GiftCodeAccount';
import NotiftyAll from 'pages/account/account-option/NotifyAll';
import NotiftyInbox from 'pages/account/account-option/NotifyInbox';
import PersonalInfo from 'pages/account/account-option/PersonalInfo';
import PresentDetail from 'pages/account/account-option/PresentDetail';
import StatsAgency from 'pages/account/account-option/StatsAgency';
import StatsDaily from 'pages/account/account-option/StatsDaily';
import StatsGeneral from 'pages/account/account-option/StatsGeneral';
import WalletDepositHistory from 'pages/account/account-option/WalletDespositHis';
import DepositPage from 'pages/deposit/DepositPage';
import FundTransfer from 'pages/fund-transfer/FundTransfer';
import WithdrawPage from 'pages/withdraw/WithDraw';
import { IconType } from 'react-icons';
import { FaUsers, FaClock, FaBell, FaChartPie, FaSyncAlt, FaUser } from 'react-icons/fa';

interface AccountItem {
    label: string;
    path?: PathTypeAccountInfo;
}

interface GroupAccountItem {
    title: string;
    id: string;
    icon?: IconType;
    group: AccountItem[];
}

interface OptionAccountComponent {
    path: PathTypeAccountInfo;
    component: React.FC;
}

export const optionAccountMenu: GroupAccountItem[] = [
    {
        title: 'Tài Khoản',
        id: 'account',
        icon: FaUser,
        group: [
            { label: 'Thông tin cá nhân', path: 'personal-info' },
            { label: 'Tin nhắn', path: 'noti-inbox' },
            { label: 'Tài khoản ngân hàng', path: 'bank-account' },
            // { label: 'Chuyển quỹ', path: 'fund-transfer' },
        ],
    },
    {
        title: 'Đại Lý',
        id: 'agency',
        icon: FaUsers,
        group: [
            { label: 'Đăng ký thành viên', path: 'agent-sign' },
            { label: 'Cấp dưới', path: 'agent-member' },
            { label: 'Liên kết đăng ký', path: 'agent-reg' },
        ],
    },
    {
        title: 'Lịch Sử',
        id: 'history',
        icon: FaClock,
        group: [
            { label: 'Biến động số dư', path: 'fund-tran' },
            { label: 'Chi tiết tặng quà', path: 'present-detail' },
            { label: 'Lịch sử cược', path: 'fund-bet' },
        ],
    },
    {
        title: 'Thông Báo',
        id: 'notify',
        icon: FaBell,
        group: [{ label: 'Tất cả thông báo', path: 'noti-all' }],
    },
    {
        title: 'Báo Cáo',
        id: 'report',
        icon: FaChartPie,
        group: [
            { label: 'Báo cáo đại lý', path: 'stats-wl' },
            { label: 'Báo cáo nhóm', path: 'stats-general' },
            { label: 'Báo cáo hằng ngày', path: 'stats-daily' },
        ],
    },
    {
        title: 'Nạp tiền - Rút tiền',
        id: 'wallet',
        icon: FaSyncAlt,
        group: [
            { label: 'Nạp Tiền', path: 'wl-depo' },
            { label: 'Lịch sử nạp/rút', path: 'wl-depo-his' },
            { label: 'Rút Tiền', path: 'wl-wdr' },
        ],
    },
];

export const optionAccountComponent: OptionAccountComponent[] = [
    { path: 'personal-info', component: PersonalInfo },
    { path: 'bank-account', component: BankAccount },
    { path: 'gift-code', component: GiftCodeAccount },
    { path: 'agent-sign', component: AgentSign },
    { path: 'agent-member', component: AgentMember },
    { path: 'agent-reg', component: AgentRegister },
    { path: 'fund-tran', component: FundAccountTransfer },
    { path: 'present-detail', component: PresentDetail },
    { path: 'fund-bet', component: FundBet },
    { path: 'noti-all', component: NotiftyAll },
    { path: 'noti-inbox', component: NotiftyInbox },
    { path: 'stats-general', component: StatsGeneral },
    { path: 'stats-wl', component: StatsAgency },
    { path: 'stats-daily', component: StatsDaily },
    { path: 'wl-depo-his', component: WalletDepositHistory },
    { path: 'wl-depo', component: DepositPage },
    { path: 'wl-wdr', component: WithdrawPage },
    { path: 'fund-transfer', component: FundTransfer },
];
